module.exports = __webpack_public_path__ + "static/DeicideWebCover_LARGE-188966eb4731042e8b2ea33fc9ecdbd4.jpeg";